import Styles from './styles.module.css';
import React from 'react';
import { IoImageOutline } from 'react-icons/io5';
import TagSection from '../../2.edit/2.tags/index';

type UploadPhotoEditorProps = {
  previewUrl?: string;
  tags: string[];
  onChangeTags: (tags: string[]) => void;
  onPick: () => void;
  error?: string;
};

// 2.edit(編集パネル)と同じタグの仕組みを、選択中の1画像分だけに絞って再利用する。
const UploadPhotoEditor: React.FC<UploadPhotoEditorProps> = ({ previewUrl, tags, onChangeTags, onPick, error }) => {
  return (
    <div className={Styles.box}>

      {previewUrl ? (
        <img className={Styles.preview} src={previewUrl} alt="" onClick={onPick} />
      ) : (
        <button type="button" className={Styles.placeholder} onClick={onPick}>
          <IoImageOutline className={Styles.placeholderIcon} />
          <span>画像を選択</span>
        </button>
      )}

      <div className={Styles.section}>
        <TagSection tags={tags} onChange={onChangeTags} error={error} />
      </div>

    </div>
  );
}

export default UploadPhotoEditor;
